import { Scrollbar } from '../core'

$.fn.ContentFilters = function() {
  let self = this
  let buffer_key = '';

  let output = self.find('.js-filtered-output').find('.grid');
  output.addClass('--has-filters')

  let content_results = new Scrollbar('.classeur__content__scrolling-container', {
    direction: 'vertical',
    desktop: true,
    mobile: false,
  })

  let classeur_wrapper = new Scrollbar('.classeur', {
    direction: 'vertical',
    desktop: false,
    mobile: true,
  })

  let classeur_filters = new Scrollbar('.content-filter-wrapper', {
    direction: 'vertical',
    desktop: true,
    mobile: false,
  })

  self.loadContents = function() {
    var temp_buffer_key = '';
    if (output.length <= 0) {
      return false;
    }
    var terms = {};
    self.find('.--selected[data-tax]').each(function() {
      if (typeof terms[$(this).attr('data-tax')] === 'undefined') {
        terms[$(this).attr('data-tax')] = [];
      }
      terms[$(this).attr('data-tax')].push($(this).attr('data-slug'));
    })
    var properties = {};
    self.find('.--selected[data-acf]').each(function() {
      if (typeof properties[$(this).attr('data-acf')] === 'undefined') {
        properties[$(this).attr('data-acf')] = [];
      }
      properties[$(this).attr('data-acf')].push($(this).attr('data-slug'));
    })
    var sort = $('.js-sort-item.--selected').attr('data-sort');
    buffer_key = temp_buffer_key = JSON.stringify(terms) + JSON.stringify(properties) + sort;
    $.ajax({
  			url: self.attr('data-action'),
  			data : {
          action: "filter_contents",
          terms: terms,
          properties: properties,
          sort: sort,
          limit: -1,//output.attr('data-limit'),
        },
  			type: 'POST',
  			beforeSend:function(xhr){
          self.find('.js-filtered-output').addClass('loading')
          self.next('.grid-row').css('--max-height', output.height() + 'px');
  			},
  			success:function(data){
          if (temp_buffer_key == buffer_key) {
            if ($(data).find('.grid').length > 0) {
              output.html($(data).find('.grid').html());
            } else {
              output.html($(data));
            }
            self.next('.grid-row').css('--max-height', output.height() + 'px');
            output.find('img').each(function() {
              picture(this);
            })
            content_results.update()
            classeur_wrapper.update()
            self.find('.js-filtered-output').removeClass('loading')
          }
  			}
  		});
  }

  self.find('.js-filter-item').click(function() {
    $(this).toggleClass('--selected');
    self.loadContents();
  })

  self.find('.js-sort-item').click(function() {
    if ($(this).hasClass('--selected')) {
      return false
    } else {
      $('.js-sort-item').removeClass('--selected')
      $(this).addClass('--selected')
      self.loadContents();
    }
  })

  $('.js-classeur').click(function() {
    $('body').toggleClass('--classeur-open')
    $('body').removeClass('--menu-open')
    $('.burger').attr('aria-expanded', 'false')
    if ($('.classeur__content__output .grid__item').length <= 0) {
      self.loadContents();
    }
  })

  return function() {
    $(window).on('load orientationchange resize', function(){
      $('.classeur-wrapper').addClass('--calculating-shrink')
      $('.classeur-wrapper').removeClass('--shrink')
      $('.classeur-wrapper').removeClass('--double-shrink')
      if ($('.classeur-wrapper .classeur').offset().top < $('.classeur-wrapper').offset().top + 20 || $('.classeur-wrapper .classeur').offset().left < $('.classeur-wrapper').offset().left) {
        $('.classeur-wrapper').addClass('--shrink')
      }
      var overflow_right = $(window).width() - ($('.classeur__content__output').offset().left + $('.classeur__content__output').width())
      if ($('.classeur-wrapper .classeur').offset().top < $('.classeur-wrapper').offset().top + 20 || overflow_right < 40) {
        $('.classeur-wrapper').addClass('--double-shrink')
      }
      $('.classeur-wrapper').removeClass('--calculating-shrink')
      classeur_filters.update()
    })
    return self
  }()
}
